/**
 * Board
 * Logic for board of tiles.
 */

// ==================== Import ====================
import Tile from './Tile';
import SymbolsGenerator from './SymbolsGenerator';
import BoardInputController from './BoardInputController';
import WordVerificator from './WordVerificator';
import ScoreCalculator from './ScoreCalculator';
import PathCreator from './PathCreator';
import ExplosionManager from './ExplosionManager';
import ClearLineAnimator from './ClearLineAnimator';

export default class Board {

    // ==================== Construction ====================
    constructor(game) {
        window.board = this;

        // Model objects
        this.game = game;
        this.view = game.make.group(); // layers of elements added in proper order, other objects uses those layers passed to them as params

        this.columnsCount = 10;
        this.rowsCount = 10;
        this.tiles = [];

        this.symbolsGenerator = new SymbolsGenerator();
        this.scoreCalculator = new ScoreCalculator();
        this.wordVerificator = new WordVerificator(game.cache.getText('words'));

        // View objects
        this.backPicture = PARAMS.makeSprite(game, -10 * PARAMS.scaleFactor, -8 * PARAMS.scaleFactor, 'boardBackgrounds', 'boardBackground1.png');
        this.view.add(this.backPicture);

        this.bgTilesViews = game.make.group();
        this.view.add(this.bgTilesViews);

        this.tilesViews = game.make.group();
        this.view.add(this.tilesViews);

        this.connectionsView = game.make.group();
        this.view.add(this.connectionsView);

        this.explosionsView = game.make.group();
        this.view.add(this.explosionsView);

        this.linesAnimView = game.make.group();
        this.view.add(this.linesAnimView);

        // Helpers
        this.boardInputController = new BoardInputController(this);
        this.pathCreator = new PathCreator(this.game, this.connectionsView, this);
        this.explosionManager = new ExplosionManager(this.game, this, this.explosionsView);
        this.clearLineAnimator = new ClearLineAnimator(this.game, this, this.bgTilesViews, this.linesAnimView);
    }

    // ==================== Initialization ====================
    init(level) {
        // Set the background picture
        this.backPicture.frameName = 'boardBackground' + ((level % 4) + 1) + '.png';

        // Reset the clear line animator
        this.clearLineAnimator.init();

        // Reset all tiles
        this.tilesViews.removeAll();
        this.tiles = [];

        // Create new tiles for the level
        for (var col = 0; col < this.columnsCount; col++) {
            this.tiles[col] = [];
            for (var row = 0; row < this.rowsCount; row++) {
                this.generateTile(col, row);
            }
        }
    }

    // ==================== Tiles ====================
    generateTile(col, row) {
        var symbol = this.symbolsGenerator.getRandomLetter(Math.random());
        var tile = new Tile(this.game, symbol, col, row);
        this.tiles[col][row] = tile;
        this.tilesViews.add(tile.view);
        return tile;
    }

    getTile(col, row) {
        return this.tiles[col][row];
    }

    placeTile(tile) {
        this.tiles[tile.col][tile.row] = tile;
    }

    putEmpty(col, row) {
        var tile = this.generateTile(col, row);
        tile.explode();
    }

    // ==================== Events ====================
    onPause() {
        this.boardInputController.active = false;
        this.boardInputController.clearSelected();
        this.pathCreator.updatePath(false);
    }

    onResume() {
        this.boardInputController.active = true;
    }

    // ==================== Destruction ====================
    destroy() {
        this.symbolsGenerator.destroy();
        this.scoreCalculator.destroy();
        this.wordVerificator.destroy();
        this.boardInputController.destroy();
        this.pathCreator.destroy();
        this.explosionManager.destroy();
        this.clearLineAnimator.destroy();

        this.backPicture.removeAll();
        this.bgTilesViews.removeAll();
        this.tilesViews.removeAll();
        this.tilesViews.removeAll();
        this.explosionsView.removeAll();
        this.linesAnimView.removeAll();
    }
}
